import { Box } from '@chakra-ui/react';

import { EquipItem, ScanningItem } from '@app/api/models';
import { FieldView, Txt } from '@app/components/common';
import { TableColumn, dateTimeBodyRender } from '@app/components/common/table';
import GalleryModal from '@app/components/common/modals/gallery';

export const scanningColumns: TableColumn<ScanningItem>[] = [
  {
    name: 'visit_result_id',
    label: 'ID',
    options: {
      filter: true,
      sort: false,
    },
  },
  {
    name: 'visit_type',
    label: 'Тип',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value, rowData) => {
        return <>{value?.name || '-'}</>;
      },
    },
  },
  {
    name: 'visit_date',
    label: 'Дата',
    options: {
      filter: {
        type: 'date',
        name: 'visit_date',
      },
      sort: true,
      customBodyRender: dateTimeBodyRender(false, false),
    },
  },
  {
    name: 'equip',
    label: 'ХО',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: EquipItem | null) => {
        if (!value) {return <Txt fontSize='sm' textColor='gray.500'>не определен</Txt>;}
        return <Box>
          <Txt textColor='brand-500'>{value.model?.name}</Txt>
          <Box display='flex' gap={2} fontSize='small' textColor='var(--chakra-colors-gray-500)'>
            <Txt fontSize='small'>{value.inventory_num}</Txt>
            <Box display='flex'>
              <Txt textColor='var(--chakra-colors-gray-700)'>SN: </Txt>
              <Txt>{value.serial_num}</Txt>
            </Box>
          </Box>
        </Box>;
      }
    }
  },
  {
    name: 'equip_active',
    label: 'Исправлено',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: EquipItem | null, { rowData }) => {
        if (!value) {return <Txt fontSize='sm' textColor='gray.500'>нет</Txt>;}
        return <Box display='flex' gap={2} flexDirection='column'>
          {value.outlet?.id !== rowData.equip?.outlet?.id && <FieldView title="ТТ" value={value.outlet?.name} />}
          {rowData.equip?.brand?.id !== value.brand?.id && <FieldView title="Бренд" value={value.brand?.name} />}
          {rowData.equip?.model?.id !== value.model?.id && <FieldView title="Модель" value={value.model?.name} />}
          {rowData.equip?.manufacturer?.id !== value.manufacturer?.id && <FieldView title="Производитель" value={value.manufacturer?.name} />}
          {rowData.equip?.serial_num !== value.serial_num && <FieldView title="Серийный номер" value={value.serial_num} />}
          {rowData.equip?.inventory_num !== value.inventory_num && <FieldView title="Инв.номер" value={value.inventory_num} />}
          {rowData.equip?.production_date !== value.production_date && <FieldView title="Дата производства" value={value.production_date} />}
        </Box>;
      }
    }
  },
  {
    name: 'images',
    label: 'Фото',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: Array<any>) => {
        return <GalleryModal  images={value || []} title="Фото" />;
      },
    },
  },
  {
    name: 'not_equal',
    label: 'Несоответствия',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: Array<string> | null) => { 
        return <>{(value || []).join(', ')}</>;
      },
    },
  },
];